import { render, staticRenderFns } from "./Mendian.vue?vue&type=template&id=57db6896"
import script from "./Mendian.vue?vue&type=script&lang=js"
export * from "./Mendian.vue?vue&type=script&lang=js"
import style0 from "./Mendian.vue?vue&type=style&index=0&id=57db6896&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports